export enum MigrationNoteType {
  Scrub = 'Scrub',
  General = 'General',
  Migration = 'Migration',
}
